<template>
  <div class="mb-3 grey lighten-3">
    <v-row
      class="mb-0 pb-0 mt-0"
      justify="start"
      align="center"
    >      
      <v-col
        cols="auto"
        class="mb-0 pa-0 ml-4"
      >
        <v-checkbox
          class="pb-0 pt-0 mt-0 mb-0 data-quality-slider"
          :label="title"
          hide-details
          v-model="show"
        >
        </v-checkbox>
      </v-col>
      <v-col
        justify="end"
        class="mb-0 pa-0"
      >
        <filter-title style="margin-top: -42px; margin-left: 248px;"
          :showResetButton="false"
          :showSettingsButton="false"
          :show="show"
          @toggle-description="showDescription = !showDescription"
          :title="title"
          :show-title="false"
        ></filter-title>
      </v-col>
    </v-row>

    <filter-description
      :title="title"
      :show="showDescription"
      :description="description"
    />
    <form @submit.prevent="updateValue">
      <v-row
        v-show="show"
        justify="start"
        align="center"
        class="mt-1"
      >

        <v-col cols="5">
          <v-text-field
            class="data-quality-slider ml-2"
            solo
            single-line
            dense
            label="Maks %"
            flat
            background-color="white"
            hide-details
            min="0"
            max="100"
            type="number"
            v-model="inputValue"
          ></v-text-field>
        </v-col>
        <v-col class="pl-0">

          <v-btn
            outlined
            :disabled="value == inputValue || inputValue === null"
            depressed
            type="submit"
          >Ok</v-btn>
        </v-col>

      </v-row>
    </form>
   
  </div>
</template>

<script>
import { FilterTitle } from "@/components/index";
import FilterDescription from "./FilterDescription";

export default {
  name: "FilterDataQualitySlider",
  components: { FilterTitle, FilterDescription },
  data: () => {
    return {
      showDescription: false,
      show: false,
      inputValue: null
    }
  },
  props: {
    description: String,
    disabled: Boolean,
    value: Number,
    title: String
  },
  watch: {
    show: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        
        if (!newVal) {
          this.inputValue = null;
          this.$emit("filter-disabled");          
        } else {
          this.$emit("filter-enabled");
        }
      }
    }
  },
  methods: {
    updateValue: function () {
      if (this.show) {
        this.$emit('input', Number(this.inputValue));
      } else {
        this.$emit('input', 100);
      }
    }
  }
}
</script>

<style>
.data-quality-slider:not(.v-input--is-focused) .v-input__slot {
  border-width: 4px 4px 4px 4px;
  border-color: #eeeeee;
  border-style: solid;
}
</style>